import { type VariantProps, cva } from 'class-variance-authority'
import clsx from 'clsx'
import * as React from 'react'

import { textVariants } from '@/components-latest/primitives/Text'

import Styles from './Badge.module.scss'

const badgeVariants = cva(Styles.badgeBase, {
  variants: {
    type: {
      number: Styles.number,
      dot: Styles.dot
    },
    size: {
      small: clsx(
        Styles.small,
        textVariants({ variant: 'overline', weight: 'bold' })
      )
    }
  },
  compoundVariants: [
    { type: 'number', size: 'small', className: Styles.smallNumber }
  ]
})

interface IBadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}
const Badge: React.FC<IBadgeProps> = ({ className, type, size, ...props }) => {
  return (
    <div
      data-testid="badge"
      className={clsx(badgeVariants({ type, size }), className)}
      {...props}
    />
  )
}

interface IWithDotProps extends React.HTMLAttributes<HTMLDivElement> {
  variant: 'negative' | 'default' | 'hidden'
}
const WithDot: React.FC<IWithDotProps> = ({ children, variant, ...props }) => (
  <div className={Styles.withDot} {...props}>
    {children}
    <Badge
      type="dot"
      className={clsx(Styles.withDotsBadge, [Styles[variant]])}
      data-testid={`badge-${variant}`}
    />
  </div>
)

export { badgeVariants, WithDot }
export default Badge
